import account from './account';
import prize from './prize';
import coin from './coin';
var m = {
  namespaced: true,
  modules: {
    account: account,
    coin: coin,
    prize: prize
  }
};
export default m;